import { fillPlot, linePlot, maTypeInput, numberInput, periodInput, sourceInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { priceReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";

const PERCENT = 100;

/**
 * Envelopes (research §1.4), as TV Envelopes: a moving average of the
 * source and lines `deviation` % above and below it (PO: 0.02 = ±0.02 %).
 */
export default {
  id: "envelopes",
  name: "Envelopes",
  isOscillator: false,
  inputs: [
    periodInput("period", "Period", 14, { max: 200 }),
    numberInput("deviation", "Deviation", 0.02, { min: 0.01, max: 100, precision: 2 }),
    maTypeInput("maType", "MA"),
    sourceInput(),
  ],
  plots: [
    linePlot("top", "Top", PALETTE.LIME),
    linePlot("middle", "Middle", PALETTE.AQUA),
    linePlot("bottom", "Bottom", PALETTE.YELLOW),
    fillPlot("background", "Background", PALETTE.LIME, ["top", "bottom"]),
  ],
  levels: [],

  calculate: (bars, { period, deviation, maType, source }, series, fromIndex) => {
    fillMovingAverage({
      type: maType,
      read: priceReader(bars, source),
      target: series.middle,
      period,
      fromIndex,
      toIndex: bars.length,
    });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.top[index] = series.middle[index] * (1 + deviation / PERCENT);
      series.bottom[index] = series.middle[index] * (1 - deviation / PERCENT);
    }
  },
};
